'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.saved.delete.linkText'
});

var _ref2 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.saved.delete.linkText'
});

var _ref3 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.saved.tip.label'
});

var _ref4 = _jsx('br', {});

var SavedTab = _react2['default'].createClass({
    displayName: 'SavedTab',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired,
        'type': _react2['default'].PropTypes.string.isRequired,
        'onBeforeInsert': _react2['default'].PropTypes.func.isRequired,
        'onInsert': _react2['default'].PropTypes.func.isRequired,
        'onClose': _react2['default'].PropTypes.func.isRequired,
        'onError': _react2['default'].PropTypes.func.isRequired,
        'isSelected': _react2['default'].PropTypes.bool.isRequired,
        'deviceOrientation': _react2['default'].PropTypes.string.isRequired,
        'screenSize': _react2['default'].PropTypes.string.isRequired,
        'savedSignatures': _react2['default'].PropTypes.object.isRequired,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired,
        'canInsertEverywhere': _react2['default'].PropTypes.bool,
        'buttonText': _react2['default'].PropTypes.string // Text to be displayed on the CTA (only when canInsertEverywhere=false)
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true
        };
    },

    getInitialState: function getInitialState() {

        var carouselLength = this.detectCarouselLength(this.props.deviceOrientation, this.props.screenSize);
        var hasSignatures = this.props.savedSignatures && this.props.savedSignatures.length > 0;
        var selectedSignatureIndex = 0;
        if (window.primarySignatureGuid && hasSignatures) {
            for (var i = 0; i < this.props.savedSignatures.length; i++) {
                if (this.props.savedSignatures[i].guid === window.primarySignatureGuid) {
                    selectedSignatureIndex = i;
                    break;
                }
            }
        }

        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'hasSignatures': hasSignatures,
            'selectedSignature': hasSignatures ? this.props.savedSignatures[selectedSignatureIndex] : null,
            'signatures': this.props.savedSignatures,
            'carouselLength': carouselLength,
            'carouselRange': [0, carouselLength - 1]
        };
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {

        var signatures = newProps.savedSignatures;
        var hasSignatures = signatures && signatures.length > 0;
        var carouselLength = 0;
        var selectedIndex = 0;
        var range = [0, 0];

        if (hasSignatures) {

            carouselLength = this.detectCarouselLength(newProps.deviceOrientation, newProps.screenSize);
            selectedIndex = this.getSelectedCarouselIndex();

            if (selectedIndex + carouselLength < signatures.length) {
                // Will be first
                range = [selectedIndex, selectedIndex + carouselLength - 1];
            } else {
                // Will be last
                range = [Math.max(0, selectedIndex - carouselLength + 1), selectedIndex];
            }
        }

        this.setState({
            'hasSignatures': hasSignatures,
            'selectedSignature': hasSignatures ? signatures[selectedIndex] : null,
            'signatures': signatures,
            'carouselLength': carouselLength,
            'carouselRange': range
        });
    },

    //  ----  BEHAVIOR  -----------------------------------

    selectSignature: function selectSignature(signature) {
        this.setState({
            'selectedSignature': signature
        });
    },

    removeSignature: function removeSignature(signature) {
        var _this = this;

        if (!window.confirm(this.props.intl.formatMessage({ id: 'signModal.saved.delete.confirmMessage.' + this.props.type }))) {
            return;
        }
        var signatures = this.state.signatures;
        var selectedSignature = this.state.selectedSignature;

        signature.remove(function (error) {
            if (error) _this.props.onError(error);else {
                if (signature.guid === selectedSignature.guid) {

                    if (signatures.length > 1) {

                        var selectedIndex = 0;
                        for (var i = 0; i < signatures.length; i++) {
                            if (signatures[i].guid === selectedSignature.guid) {
                                selectedIndex = i;
                                break;
                            }
                        }

                        selectedSignature = signatures[selectedIndex + 1];
                        if (selectedSignature === undefined || _this.state.carouselLength > 1 && !_this.isInCarouselRange(selectedIndex + 1)) {
                            selectedSignature = signatures[selectedIndex - 1];
                        }
                        _this.selectSignature(selectedSignature);

                        // TODO - remove this - this is breaking encapsulation majorly. This sort
                        // of logic should be within the signatures collection (CC)
                        signatures.splice(selectedIndex, 1);
                    } else {

                        // The last signature just got deleted so pop the last one out
                        signatures.splice(0, 1);
                        _this.selectSignature(null);
                        window.primarySignatureGuid = void 0;
                    }
                }

                var sigReq = _this.props.app.signatureRequest;
                var selectedSig;
                if (sigReq) selectedSig = sigReq.getSelectedSignature(_this.props.type);
                if (selectedSig && selectedSig.guid === signature.guid) {
                    // Reset the selected signature if it'a been deleted
                    sigReq.setSelectedSignature(_this.props.type, null);
                }

                _this.setState({
                    'signatures': signatures,
                    'hasSignatures': signatures.length > 0
                });
            }
        });
    },

    insertSignature: function insertSignature(insertEverywhere) {
        var signature = this.state.selectedSignature;
        if (!this.props.onBeforeInsert || this.props.onBeforeInsert(signature) !== false) {
            this.props.onInsert(signature, insertEverywhere);
        }
    },

    shiftCarousel: function shiftCarousel(dir) {

        var range;
        var numItems = this.state.signatures.length;

        switch (dir) {

            case 'next':
                range = [this.state.carouselRange[0] + 1, Math.min(this.state.carouselRange[1] + 1, numItems - 1)];
                break;

            case 'prev':
                range = [Math.max(0, this.state.carouselRange[0] - 1), this.state.carouselRange[1] - 1];
                break;

            default:
                throw new Error('Invalid direction: ' + dir);
        }

        // Ensure the current selected signature is still visible in the carousel.
        // Find the closest visible if not.
        var selectedSignature = this.state.selectedSignature;
        var selectedIndex = this.getSelectedCarouselIndex();
        if (!this.isInCarouselRange(selectedIndex, range)) {
            if (selectedIndex < range[0]) {
                selectedSignature = this.state.signatures[range[0]];
            }
            if (selectedIndex > range[1]) {
                selectedSignature = this.state.signatures[range[1]];
            }
        }

        this.setState({
            'carouselRange': range,
            'selectedSignature': selectedSignature
        });
    },

    //  ----  HELPERS  ------------------------------------

    getSelectedCarouselIndex: function getSelectedCarouselIndex() {
        if (typeof this.state.selectedSignature === 'undefined' || this.state.selectedSignature === null) {
            return 0;
        }
        var selectedSignature = this.state.selectedSignature;
        var selectedIndex = 0;
        for (var i = 0; i < this.state.signatures.length; i++) {
            if (this.state.signatures[i].guid === selectedSignature.guid) {
                selectedIndex = i;
                break;
            }
        }
        return selectedIndex;
    },

    detectCarouselLength: function detectCarouselLength(orientation, screenSize) {
        if (screenSize === _constants2['default'].SCREEN_SMALL) {
            if (orientation === _constants2['default'].ORIENTATION_PORTRAIT) {
                // Only show one on small screen when in portrait mode
                return 1;
            } else {
                // But show two when in landscape mode
                return 3;
            }
        } else {
            // Default
            return _constants2['default'].CAROUSEL_LENGTH;
        }
    },

    scaleSignatureToFit: function scaleSignatureToFit(origDims, restrictDims) {
        origDims = Object.assign({}, origDims);
        origDims.ratio = parseFloat(origDims.width / origDims.height);
        if (origDims.width > origDims.height) {
            origDims.width = restrictDims.width;
            origDims.height = parseInt(origDims.width / origDims.ratio, 10);
            if (origDims.height > restrictDims.height) {
                origDims.height = restrictDims.height;
                origDims.width = parseInt(origDims.height * origDims.ratio, 10);
            }
        } else {
            origDims.height = restrictDims.height;
            origDims.width = parseInt(origDims.height * origDims.ratio, 10);
            if (origDims.width > restrictDims.width) {
                origDims.width = restrictDims.width;
                origDims.height = parseInt(origDims.width / origDims.ratio, 10);
            }
        }
        return origDims;
    },

    isInCarouselRange: function isInCarouselRange(i, range) {
        if (range === undefined) {
            range = this.state.carouselRange;
        }
        return i >= range[0] && i <= range[1];
    },

    //  ----  RENDERING  ----------------------------------

    renderSignatureImage: function renderSignatureImage(signature, isThumbnail) {

        if (!signature) return;

        var url = signature.getUrl();
        var dims;
        var containerDims = {
            'width': 75,
            'height': 40
        };

        if (isThumbnail) {
            dims = this.scaleSignatureToFit({
                'width': signature.width,
                'height': signature.height
            }, containerDims);
        } else {
            dims = {
                'width': 2 * signature.width,
                'height': 2 * signature.height
            };
        }

        var topMargin = Math.max(0, parseInt((containerDims.height - dims.height) / 2, 10));
        var style = {
            'marginTop': topMargin + 'px',
            'width': dims.width + 'px',
            'height': dims.height + 'px'
        };

        return _jsx('img', {
            src: url,
            guid: signature.guid,
            style: style
        });
    },

    renderSignatureCarousel: function renderSignatureCarousel() {

        var carouselItems = [];
        var classes;
        var guid;
        var inRange;
        var signature;

        for (var i = 0; i < this.state.signatures.length; i++) {

            signature = this.state.signatures[i];

            classes = {
                'm-sign-modal--tabs--saved--carousel--item': true,
                'whitelabel-signature-modal-save-carousel-tab-item': true,
                'is-selected': this.state.selectedSignature.guid === signature.guid,
                'is-hidden': !this.isInCarouselRange(i)
            };

            carouselItems.push(_jsx('li', {
                index: i,
                className: (0, _classnames2['default'])(classes)
            }, 'carousel-item-' + i, _jsx('div', {
                className: 'm-sign-modal--tabs--saved--carousel--item--content',
                onClick: this.selectSignature.bind(null, signature)
            }, void 0, this.renderSignatureImage(signature, true)), _jsx('div', {
                className: 'm-sign-modal--tabs--saved--carousel--item--delete',
                onClick: this.removeSignature.bind(null, signature)
            }, void 0, _ref)));
        }

        classes = {
            'm-sign-modal--tabs--saved--carousel--list': true,
            'with-arrows': this.state.signatures.length > _constants2['default'].CAROUSEL_LENGTH
        };

        if (this.state.carouselRange[0] > 0) {
            leftArrow = _jsx('li', {
                className: 'm-sign-modal--tabs--saved--carousel--arrow prev',
                onClick: this.shiftCarousel.bind(null, 'prev')
            });
        }

        // Arrows
        var leftArrowEnabled = this.state.carouselRange[0] > 0;
        var rightArrowEnabled = this.state.carouselRange[1] < this.state.signatures.length - 1;
        var leftArrow = _jsx('li', {
            className: (0, _classnames2['default'])({
                'm-sign-modal--tabs--saved--carousel--arrow': true,
                'prev': true,
                'is-disabled': !leftArrowEnabled
            }),
            onClick: leftArrowEnabled ? this.shiftCarousel.bind(null, 'prev') : null
        });
        var rightArrow = _jsx('li', {
            className: (0, _classnames2['default'])({
                'm-sign-modal--tabs--saved--carousel--arrow': true,
                'next': true,
                'is-disabled': !rightArrowEnabled
            }),
            onClick: rightArrowEnabled ? this.shiftCarousel.bind(null, 'next') : null
        });

        return _jsx('div', {
            className: 'm-sign-modal--tabs--saved--carousel--clip'
        }, void 0, _jsx('ul', {
            className: (0, _classnames2['default'])(classes)
        }, void 0, leftArrow, carouselItems, rightArrow));
    },

    renderSignatureList: function renderSignatureList() {

        var listItems = [];
        var classes;
        var isSelected;
        var signature;
        var deleteBtn;

        for (var i = 0; i < this.state.signatures.length; i++) {

            signature = this.state.signatures[i];
            isSelected = signature.guid === this.state.selectedSignature.guid;
            deleteBtn = isSelected ? _jsx('div', {
                className: 'm-sign-modal--tabs--saved--list--item--delete',
                onClick: this.removeSignature.bind(null, signature)
            }, void 0, _ref2) : null;
            classes = {
                'm-sign-modal--tabs--saved--list--item': true,
                'is-selected': isSelected
            };
            listItems.push(_jsx('div', {
                className: (0, _classnames2['default'])(classes),
                onClick: this.selectSignature.bind(null, signature)
            }, void 0, _jsx('div', {
                className: 'm-sign-modal--tabs--saved--list--item--image'
            }, void 0, this.renderSignatureImage(signature)), deleteBtn));
        }

        return _jsx('div', {
            className: 'm-sign-modal--tabs--saved--list'
        }, void 0, listItems);
    },

    render: function render() {

        var emptyMessage;
        var featuredSignature;
        var carousel;
        var carouselTip;
        var tabTitle;

        if (this.state.hasSignatures) {

            if (this.props.isMobile) {

                // Render the list of signatures
                carousel = this.renderSignatureList();
            } else {

                tabTitle = _jsx('span', {
                    className: 'm-sign-modal--tabs--tab-title'
                }, void 0, _jsx(_reactIntl.FormattedMessage, {
                    id: 'signModal.saved.title',
                    values: { type: this.props.type }
                }));

                // Featured signature or initials
                featuredSignature = _jsx('div', {
                    className: 'm-sign-modal--tabs--saved--featured'
                }, void 0, this.renderSignatureImage(this.state.selectedSignature));

                // Carousel tip
                carouselTip = _jsx('div', {
                    className: 'm-sign-modal--tabs--saved--carousel--tip'
                }, void 0, _jsx('p', {}, void 0, _ref3, ': ', _ref4, _jsx(_reactIntl.FormattedMessage, {
                    id: 'signModal.saved.tip.text',
                    values: { type: this.props.type }
                })));

                // Carousel
                carousel = _jsx('div', {
                    className: 'm-sign-modal--tabs--saved--carousel'
                }, void 0, carouselTip, this.renderSignatureCarousel());
            }
        } else {

            // No signatures or initials
            emptyMessage = _jsx('div', {
                className: 'm-sign-modal--tabs--saved--empty'
            }, void 0, _jsx('h2', {}, void 0, _jsx(_reactIntl.FormattedMessage, {
                id: 'signModal.saved.empty.text',
                values: { type: this.props.type }
            })), _jsx('p', {}, void 0, _jsx(_reactIntl.FormattedMessage, {
                id: 'signModal.saved.empty.subText',
                values: { type: this.props.type }
            })));
        }

        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_SAVED] = true;

        var classes = {
            'm-sign-modal--tabs--saved': true,
            'has-signatures': this.state.hasSignatures
        };

        return _jsx('div', {
            className: (0, _classnames2['default'])(containerClasses)
        }, void 0, tabTitle, _jsx('div', {
            className: (0, _classnames2['default'])(classes)
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--tabs--content'
        }, void 0, emptyMessage, featuredSignature, carousel)), _react2['default'].createElement(_actionBar2['default'], _extends({}, this.props, {
            type: this.props.type,
            isMobile: this.props.isMobile,
            locales: this.props.locales,
            messages: this.props.messages,
            onInsert: this.insertSignature,
            onClose: this.props.onClose,
            canInsertEverywhere: this.props.canInsertEverywhere,
            disableButtons: !this.state.hasSignatures,
            buttonText: this.props.buttonText,
            message: null })));
    }
});

module.exports = SavedTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/saved-tab.jsx
 ** module id = 679
 ** module chunks = 0
 **/